<template></template>
<script>
export default{
		data() {
			return {
				uuid:'',
			}
		},
		components: {
			
		},
		mounted(){
			this.uuid = this.$route.query.uuid;
			this.$router.push({
				path: 'repository1',
				query: {
					uuid: this.uuid
				}
			})
		},
		methods: {}
	}
</script>
<style></style>


// WEBPACK FOOTER //
// src/views/correlation.vue